import { useMemo } from "react";
import { Body, Form } from "domains/3d/interfaces";
import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

export function useGetBody({
  model,
  form,
}: {
  model: GetModelsByModelIdApiResponse["model"] | undefined;
  form: Form;
}): Body | undefined {
  return useMemo(() => {
    return model?.inputs?.reduce((acc, field) => {
      const value = form[field.name];
      if (
        value &&
        typeof value === "object" &&
        "url" in value &&
        "id" in value
      ) {
        acc[field.name] = value.id;
      } else if (
        value &&
        Array.isArray(value) &&
        value.every((v) => typeof v === "object" && "url" in v && "id" in v)
      ) {
        acc[field.name] = value.map((v) => v.id);
      } else if (typeof value !== "object" || Array.isArray(value)) {
        acc[field.name] = value;
      }
      return acc;
    }, {} as Body);
  }, [form, model]);
}
